<template>
  <div>
            <child3></child3>
  </div>
</template>

<script>
import child3 from '../user/children/child3.vue'
export default {
    components:{child3},
    
}
</script>

<style>

</style>